export class DrugRequirementList {
    public constructor(
    ) {
        this.productTypeList = [];
        this.drugGenericList = [];
        this.drugFormList = [];
    }

    public productTypeList: any[];
    public drugGenericList: any[];
    public drugFormList: any[];
}
